import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { computed, inject } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'IntroducingSection',
  setup(__props) {

const store: any = inject(`store`);
const displayWidth: any = inject(`displayWidth`);

const computedDisplayWidth = computed(() => {
  return displayWidth.value < 700;
});

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass({section:true,mobile:computedDisplayWidth.value})
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "title" }, "Navigating the digital landscape for success", -1)),
    _createElementVNode("img", {
      class: "image",
      src: require(`../assets/introduction.png`),
      alt: "Social Media"
    }, null, 8, _hoisted_1),
    _cache[2] || (_cache[2] = _createElementVNode("p", null, " Our digital marketing agency helps businesses grow and succeed online through a range of services including SEO, PPC, social media marketing, and content creation. ", -1)),
    _createVNode(_component_BaseButton, {
      color: "black",
      center: computedDisplayWidth.value,
      class: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).dispatch(`scrollToAction`, `contact`))),
      text: "Book a consultation"
    }, null, 8, ["center"])
  ], 2))
}
}

})